import * as React from 'react'
import { Route, Switch } from 'react-router'
import VehicleInfo from './VehicleInfo'
import Products from './Products'
import AccessCapacity from './AccessCapacity'
import Accommodations from './Accommodations'
import { IMap, IProviderObject, IVehicleObj } from '../../../types'
import { IProviderProductObject } from '../../../types/provider-product'

interface IViewVehicleRoutProps {
  path: string
  vehicle: IVehicleObj
  providers: IMap<IProviderObject>
  providerProduct: IMap<IProviderProductObject>
}

const ViewVehicleRoute = (props: IViewVehicleRoutProps) => {
  const VehicleInfoWrap = () => <VehicleInfo vehicle={props.vehicle} />
  const ProductsWrap = () => <Products vehicle={props.vehicle} providerProduct={props.providerProduct} />
  const AccessCapacityWrap = () => <AccessCapacity vehicle={props.vehicle} />
  const AccommodationsWrap = () => <Accommodations vehicle={props.vehicle} />
  return (
    <Switch>
      <Route path={`${props.path}/details`} exact={true} component={VehicleInfoWrap} />
      <Route path={`${props.path}/products`} component={ProductsWrap} />
      <Route path={`${props.path}/access-capacity`} component={AccessCapacityWrap} />
      <Route path={`${props.path}/accommodations`} component={AccommodationsWrap} />
    </Switch>
  )
}

export default ViewVehicleRoute



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/ViewVehicleRoute.tsx